import { render, staticRenderFns } from "./admin-sciences.vue?vue&type=template&id=4912f911&scoped=true"
import script from "./admin-sciences.vue?vue&type=script&lang=js"
export * from "./admin-sciences.vue?vue&type=script&lang=js"
import style0 from "./admin-sciences.vue?vue&type=style&index=0&id=4912f911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4912f911",
  null
  
)

export default component.exports